import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { isSuperSpeedActiveSelector } from 'swag-client-common/redux/settings/settings.selectors';
import { removeSuperSpeedProductIdFromLS } from 'swag-client-common/utils/super-speed-local-storage.utils';
import { currentProductionTimeListSelector, isCustomizedBlankSelector, isLimitedEditionSelector, isRebuildCBSProductModeSelector } from '../../../../../../../../redux/product/product.selectors';
import { changeIsCustomizedBlank, changeTime } from '../../../../../../../../redux/product/product.actions';
import { getDefaultProductionTimeIdx } from '../../../../../../../../redux/product/product.utils';
import { resetLogos } from '../../../../../../../../redux/logo-editing/logo-editing.actions';
import { CustomizeBlank } from './customize-blank';
const mapStateToProps = createStructuredSelector({
  isCustomizedBlank: isCustomizedBlankSelector,
  isLimitedEdition: isLimitedEditionSelector,
  isSuperSpeed: isSuperSpeedActiveSelector,
  productionTimeList: currentProductionTimeListSelector,
  isDisabled: isRebuildCBSProductModeSelector
});
const mapDispatchToProps = dispatch => ({
  onChange: ({
    isBlank,
    isSuperSpeed,
    productionTimeList: list
  }) => {
    if (isBlank) {
      if (isSuperSpeed) {
        const defaultProdTimeIdx = getDefaultProductionTimeIdx(list);
        dispatch(changeTime(defaultProdTimeIdx));
        removeSuperSpeedProductIdFromLS();
      }
      dispatch(resetLogos());
    }
    dispatch(changeIsCustomizedBlank(isBlank));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(CustomizeBlank);